// extracted by mini-css-extract-plugin
module.exports = {"caseStudy":"__caseStudy__sg1if","valueOutcome":"__valueOutcome__Q1Rmk"};